export const sortKeys = [
  {
    text: 'Recommended',
    code: 'sortBy=position&sortDir=ASC',
    shortCode: 'position-ASC',
  },
  {
    text: 'LowestPrice',
    code: 'sortBy=price&sortDir=ASC',
    shortCode: 'price-ASC',
  },
  {
    text: 'HighestPrice',
    code: 'sortBy=price&sortDir=DESC',
    shortCode: 'price-DESC',
  },
  {
    text: 'HighestDiscount',
    code: 'sortBy=special_price&sortDir=DESC',
    shortCode: 'special_price-DESC',
  },
  {
    text: 'newestArrivals',
    code: 'sortBy=created_at&sortDir=DESC',
    shortCode: 'created_at-DESC',
  },
];

export const SHIPPING_INFO_MODALS_NAMES = {
  SHIPPING_METHOD: 'shippingMethod',
  DELIVERY_ADDRESS: 'deliveryAddress',
  ADD_ADDRESS_OPTIONS: 'addAddressOptions',
  ADD_EDIT_ADDRESS: 'addEditAddress',
  CHOOSE_BRANCH: 'chooseBranch',
  UNAVAILABLE_ITEMS_BRANCHES: 'unavailableItemsBranches',
  HOME_DELIVERY: 'Homedelivery',
  STORE_PICKUP: 'storepickup',
};

export const ADDRESS_MODES = {
  NATIONAL: 'nation',
  AUTO: 'auto',
  Manual: 'manual',
};

export const PRICE_FILTER_KEY = 'price.SAR.default';

export const BRAND_CATEGORY_ID = 244;

export const PRODUCT_UNAVAILABLE_ACTION = {
  CALL_TO_CONFIRM: 'call_to_confirm',
  PREPARE_WITHOUT_MISSING_PRODUCT: 'prepare_without_missing_product',
  CHOOSE_ALTERNATIVE: 'choose_alternative_if_exists',
};

export const FREE_DELIVERY_LIMIT = 100;
